module.exports = __webpack_public_path__ + "static/media/stakePromo.bc157c4c.jpg";